'use client';

import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';
import { EnergyType } from '@energy-retailer/constants';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export default function DeepLinkParser() {
  const { setCheckboxChecked } = useJoinFormStore();
  const searchParams = useSearchParams();
  const search = searchParams.get('fuel');

  useEffect(() => {
    switch (search) {
      case 'electricity':
        setCheckboxChecked(EnergyType.Electricity, true);
        setCheckboxChecked(EnergyType.Gas, false);
        break;
      case 'gas':
        setCheckboxChecked(EnergyType.Electricity, false);
        setCheckboxChecked(EnergyType.Gas, true);
        break;
      default:
        // The default is both so only need to handle
        // each case for specific deep links
        break;
    }
  }, []);

  return null;
}
